"use client";

import YouTube, { YouTubeProps } from "react-youtube";
import { twMerge } from "tailwind-merge";

export function BlogVideo({
  youtubeId,
  startTimestamp,
  className,
}: {
  youtubeId: string;
  startTimestamp?: number;
  className?: string;
}) {
  const opts: YouTubeProps["opts"] = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      rel: 0,
      start: startTimestamp === undefined ? 0 : startTimestamp,
    },
  };

  return (
    <div
      className={twMerge("aspect-h-9 aspect-w-16 relative w-full", className)}
    >
      <YouTube videoId={youtubeId} opts={opts} />
    </div>
  );
}
